import axios from 'axios'

export const HTTP_MODE = {
  API: 'api',
  STANDALONE: 'standalone'
}

class HttpService {
  constructor () {
    this.mode = HTTP_MODE.API
  }

  get isStandalone () {
    return this.mode === HTTP_MODE.STANDALONE
  }

  initialize (mode = HTTP_MODE.API) {
    this.mode = mode
    this.setDefaults()
  }

  setDefaults () {
    axios.defaults.baseURL = this.getBaseURL()
    axios.defaults.withCredentials = true
  }

  getBaseURL () {
    if (this.isStandalone) {
      return ''
    }
    return `//${__CONFIG__.apiHost || window.location.hostname}:${__CONFIG__.apiPort}/`
  }

  async checkResourceExists (url) {
    try {
      const response = await axios.get(url)
      return response.status === 200
    } catch (e) {
      return false
    }
  }
}

export const httpService = new HttpService()
